/**
 * TODO: Définir le type d'erreur API.
 */
export type ApiError = {
  error: Record<string, unknown>;
  message: string;
  status: number | null;
  data: unknown;
};
type ApiResponseData<T> = {
  success: boolean;
  data: T;
};
type ApiResponseDeprecated<T> = T & {
  success: boolean;
};
export type ApiResponse<T> = ApiResponseData<T> | ApiResponseDeprecated<T>;
/**
 * Type guard pour distinguer le nouveau format (avec data) de l'ancien format (données à plat).
 */
export function isApiResponseData<T>(response: ApiResponse<T>): response is ApiResponseData<T> {
  return (
    response !== null &&
    typeof response === 'object' &&
    'data' in response 
  );
}
/**
 * Extrait les données d'une réponse API (compatible ancien et nouveau format).
 */
export function extractApiData<T>(response: ApiResponse<T>): T {
  if (isApiResponseData(response)) {
    return response.data;
  }
  // Format deprecated : on retire juste le champ success
  const { success: _success, ...data } = response;
  return data as T;
}